module.exports = "mutation EstimateFees($departementId:ID!){estimateFees(departementId:$departementId){success}}"